import { Button, Dialog, DialogActions, Box, DialogContent, TextField, IconButton, DialogTitle, Typography, FormHelperText, Divider } from '@mui/material';
import { setSuccessfullModifyDialog } from '../../../redux/successfullModifyDialogSlice';
import { setCompanyDetailsData } from '../../../redux/companyDetailsDataSlice';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { CustomPhoneInput } from '../../../utils/customPhoneInput';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useCallback, useState } from 'react';
import { useFormik } from 'formik';
import Iconify from '../../Iconify';
import * as Yup from 'yup';
import axios from 'axios';
import '../../../css/sites/addSiteRelation.css';

export const EditcompanyContact = ({ openEditContact, setOpenEditContact, contactToEdit }) => {

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const CompanyDetailsData = useSelector((state) => state?.CompanyDetailsData);

    const [errMsg, setErrMsg] = useState(null);

    const formik = useFormik({
        initialValues: {
            name: contactToEdit?.name || '',
            phone_number: contactToEdit?.phone_number || '',
            email: contactToEdit?.email || '',
            post: contactToEdit?.post || '',
        },
        validationSchema: Yup.object().shape({
            name: Yup.string().required(t('isRequired')),
            phone: Yup.string().trim().matches(/^\+?[0-9]+$/, t('PhoneNumberOnlyDigits')).min(8, t('PhoneNumberMinLength')).optional(),
            email: Yup.string().email(t('invalidEmail')).optional(),
            post: Yup.string().optional(),
        }),
        onSubmit: async (values) => {
            try {
                const response = await axios.patch(`company-contact/${contactToEdit?.id}`, values);
                if (response.status === 200 || response.status === 201) {
                    dispatch(setCompanyDetailsData({
                        ...CompanyDetailsData,
                        company_contact: CompanyDetailsData?.company_contact?.map((contact) =>
                            contact?.id === contactToEdit?.id ? response?.data : contact
                        ),
                    }));
                    dispatch(setSuccessfullModifyDialog({ open: true, type: 'Modifier un contact' }));
                    setOpenEditContact(false);
                }
            } catch (error) {
                setErrMsg(error.message);
                console.error('Error updating relation:', error);
                CustomErrorLogger(error, "error updating relation in EditSiteRelation");
            }
        }
    });

    const { handleSubmit, values, touched, errors, setFieldValue, handleChange, handleBlur } = formik;

    const handleClose = useCallback(() => {
        setOpenEditContact(false);
    }, [setOpenEditContact]);

    return (
        <Dialog open={openEditContact} fullWidth maxWidth='md'>
            <IconButton onClick={handleClose} className='addSiteRelation_icon_button'>
                <Iconify icon="material-symbols:close" className='addSiteRelation_close_icon' />
            </IconButton>
            <DialogTitle className='addSiteRelation_dialog_title'>Modifier un contact</DialogTitle>
            <Divider />
            <form onSubmit={handleSubmit}>
                {errMsg && <Typography className='errMsg'>{errMsg}</Typography>}
                <DialogContent className='addSiteRelation_dialog_content'>
                    <Box className="addUser_helper_selct_box">
                        <FormHelperText id="outlined-weight-helper-text" className="addUserInputTitle">Nom complet</FormHelperText>
                        <TextField
                            fullWidth
                            value={values.name}
                            className='addUser_InputField'
                            id="outlined-adornment-weight"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="name"
                            error={touched.name && Boolean(errors.name)}
                            helperText={touched.name && errors.name}
                            aria-describedby="outlined-weight-helper-text"
                        />
                    </Box>
                    <Box className="addUser_helper_selct_box">
                        <FormHelperText id="outlined-weight-helper-text" className="addUserInputTitle">{t('Téléphone')} (optionnel)</FormHelperText>
                        <CustomPhoneInput
                            name="phone_number"
                            value={values.phone_number}
                            onChange={(value) => setFieldValue('phone_number', value)}
                        />
                    </Box>
                    <Box className="addUser_helper_selct_box">
                        <FormHelperText id="outlined-weight-helper-text" className="addUserInputTitle">{t('email')} (optionnel)</FormHelperText>
                        <TextField
                            fullWidth
                            value={values.email}
                            className='addUser_InputField'
                            id="outlined-adornment-weight"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="email"
                            error={touched.email && Boolean(errors.email)}
                            helperText={touched.email && errors.email}
                            aria-describedby="outlined-weight-helper-text"
                        />
                    </Box>
                    <Box className="addUser_helper_selct_box">
                        <FormHelperText id="outlined-weight-helper-text" className="addUserInputTitle">Fonction (optionnel)</FormHelperText>
                        <TextField
                            fullWidth
                            value={values.post}
                            className='addUser_InputField'
                            id="outlined-adornment-weight"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="post"
                            error={touched.post && Boolean(errors.post)}
                            helperText={touched.post && errors.post}
                            aria-describedby="outlined-weight-helper-text"
                        />
                    </Box>
                </DialogContent>
                <DialogActions className='addSiteRelation_dialog_actions'>
                    <Button className='addSiteRelation_button_annuler' onClick={handleClose}>{t('Annuler')}</Button>
                    <Button className='addSiteRelation_button_valider' variant="contained" type="submit">{t('Valider')}</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};